import * as React from "react"

const Cross = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m7.3 8-2.7 2.6-.3.4.7.7.4-.3L8 8.7l2.6 2.7.4.3.7-.7-.3-.4L8.7 8l2.7-2.6.3-.4-.7-.7-.4.3L8 7.3 5.4 4.6 5 4.3l-.7.7.3.4L7.3 8Z" />
  </svg>
)

export default Cross
